// PATTERN 1 - First Pattern
export const pattern1 = [
  {
    letter: "A",
    question: "¿Cuál era la temática del mod que tanto lloró Bruno?",
    answer: "aviones"
  },
  {
    letter: "B",
    question: "¿Lugar a donde no vamos a poder viajar por una promesa de Facundo a su novia?",
    answer: "bariloche"
  },
  {
    letter: "C",
    question: "Completa la frase \"La carita de...\"",
    answer: "cógeme es increíble"
  },
  {
    letter: "D",
    question: "¿Nombre del torneo realizado en el último cumple de Manuel?",
    answer: "devilman cup"
  },
  {
    letter: "E",
    question: "¿Autor del gol que le otorgó a Nacional el uruguayo?",
    answer: "ebere"
  },
  {
    letter: "F",
    question: "¿El mejor hijo de Julio Perera?",
    answer: "felipe"
  },
  {
    letter: "G",
    question: "¿Apellido del tercero en el balón de oro del año pasado?",
    answer: "garay"
  },
  {
    letter: "H",
    question: "¿Nombre de la persona por la que Manuel abandonó un partido por miedo?",
    answer: "hugo"
  },
  {
    letter: "I",
    question: "¿Con qué famoso conductor de TV se encontraron Nacho y Manuel?",
    answer: "ivan de pineda"
  },
  {
    letter: "J",
    question: "¿Nombre del ex interés amoroso de Nacho?",
    answer: "jessica"
  },
  {
    letter: "K",
    question: "¿Bebida con la que Pablo causó 'la masacre de Atlantida'?",
    answer: "vodka"
  },
  {
    letter: "L",
    question: "¿Con qué creepypasta quedó atrapado Cristian en el escape room de terror?",
    answer: "la monja"
  },
  {
    letter: "M",
    question: "Completa la frase \"Ayer en clase de futbol, jugué 10 partidos y me di cuenta como no hacen...\"",
    answer: "medio pase, ustedes"
  },
  {
    letter: "N",
    question: "¿Nombre del servidor de Minecraft con eventos?",
    answer: "nordicscraft"
  },
  {
    letter: "O",
    question: "¿Perro de Facundo que no es Bruno?",
    answer: "mateo"
  },
  {
    letter: "P",
    question: "¿Dónde fuimos en enero del 2025?",
    answer: "punta del diablo"
  },
  {
    letter: "Q",
    question: "¿Dueño del bolsillo en el que está permanentemente Pablo?",
    answer: "roque"
  },
  {
    letter: "R",
    question: "¿Qué famoso audio se escucha en el video donde Facundo golpea con guantes inflables a Bruno?",
    answer: "recordemos que viruzz es zurdo"
  },
  {
    letter: "S",
    question: "¿Nombre del evento deportivo que se jugaba el domingo que fuimos a Argentina?",
    answer: "superclásico"
  },
  {
    letter: "T",
    question: "¿Evento grupal realizado en septiembre del 2025?",
    answer: "the mendez mystery"
  },
  {
    letter: "U",
    question: "¿Quién no gana una línea sino es con Akali?",
    answer: "bruno"
  },
  {
    letter: "V",
    question: "¿Nombre o apodo de la mujer que funó a Facundo?",
    answer: "vica"
  },
  {
    letter: "W",
    question: "¿Ganadora de la burger del año?",
    answer: "wakanda"
  },
  {
    letter: "X",
    question: "¿Nombre de un entrenador el cual decían que ganaría todo y lo echaron a los 6 meses?",
    answer: "xabi alonso"
  },
  {
    letter: "Y",
    question: "¿Nombre del presidente que votó Bruno?",
    answer: "yamandú"
  },
  {
    letter: "Z",
    question: "¿Número en inglés que refleja la cantidad de eventos que participó Manuel de Nordicscraft?",
    answer: "zero"
  }
];

// PATTERN 2 - Second Pattern
export const pattern2 = [
  {
    letter: "A",
    question: "¿Apodo recurrente que le da Bruno a los que no entran a hablar en Discord?",
    answer: "autista"
  },
  {
    letter: "B",
    question: "¿Equipo del campeón de Nordififa?",
    answer: "bayern leverkusen"
  },
  {
    letter: "C",
    question: "¿Dorsal de Maciel con la camiseta de Nórdicos?",
    answer: "cuatro"
  },
  {
    letter: "D",
    question: "¿Nombre en el dorso de la remera de Nórdicos de Manuel?",
    answer: "dragonsenpai"
  },
  {
    letter: "E",
    question: "¿Nombre del movimiento estrella de Maciel?",
    answer: "ruleta"
  },
  {
    letter: "F",
    question: "¿Nombre del evento grupal deportivo realizado sin el organizador?",
    answer: "futbol sin pablo"
  },
  {
    letter: "G",
    question: "¿Dicho de una persona, por ejemplo Bruno, cuando dice cualquier cosa?",
    answer: "gagá"
  },
  {
    letter: "H",
    question: "Completa la frase \"Llámenme... porque le voy a meter un niño a ese animatronico\"",
    answer: "hombre de morado"
  },
  {
    letter: "I",
    question: "¿Jugador que le brindó la primera asistencia a Luis Suárez en su retorno a Nacional?",
    answer: "brian ocampo"
  },
  {
    letter: "J",
    question: "¿Con qué personaje mítico se sacó foto Cristian en una Frikifest?",
    answer: "jinx"
  },
  {
    letter: "K",
    question: "¿Mítica película que referenció JJK en el capítulo de la masacre Zenin?",
    answer: "kill bill"
  },
  {
    letter: "L",
    question: "¿Maciel, al revés?",
    answer: "leicam"
  },
  {
    letter: "M",
    question: "¿El juego variado que juega Bruno luego de decir que siempre jugamos a lo mismo?",
    answer: "marvel rivals"
  },
  {
    letter: "N",
    question: "Completa la frase \"Unas ganas de hacerle el amor a una...\"",
    answer: "nenita toda la noche"
  },
  {
    letter: "O",
    question: "¿Rango al que llegó Facundo antes que Bruno habiendo jugado menos de la mitad del tiempo al LoL?",
    answer: "oro"
  },
  {
    letter: "P",
    question: "¿Pokémon favorito de Manuel?",
    answer: "pichu"
  },
  {
    letter: "Q",
    question: "¿Respuesta usual de Bruno hacia las insinuaciones homosexuales de los muchachos?",
    answer: "que asco"
  },
  {
    letter: "R",
    question: "¿Nombre del equipo más beneficiado por los árbitros históricamente?",
    answer: "real madrid"
  },
  {
    letter: "S",
    question: "¿Precio de la Maverick Doble?",
    answer: "setecientos sesenta"
  },
  {
    letter: "T",
    question: "Completa la frase \"Cuando vas al casino y \"",
    answer: "te follan por el culo"
  },
  {
    letter: "U",
    question: "En inglés, ¿qué días no puede Facundo?",
    answer: "saturdays"
  },
  {
    letter: "V",
    question: "¿Nombre de la enfermedad que Manuel se inventó para no ir a mi último cumpleaños?",
    answer: "varicela"
  },
  {
    letter: "W",
    question: "¿Apodo que se le dió a uno de los juegos que más jugó Manuel el año pasado?",
    answer: "walk simulator"
  },
  {
    letter: "X",
    question: "¿Red social más utilizada para mandar noticias al Discord?",
    answer: "x"
  },
  {
    letter: "Y",
    question: "¿Con qué mítica frase justifica Bruno pedir futbol futbol pero no organizarlo?",
    answer: "yo solo expresé mis ganas"
  },
  {
    letter: "Z",
    question: "¿Persona a la que Nacho envidia por haber estado con Belén?",
    answer: "ezequiel"
  }
];

// PATTERN 3 - South Team
export const pattern3 = [
  {
    letter: "A",
    question: "¿En cuántas ocasiones aparecimos en historias de Instagram?",
    answer: "apariciones"
  },
  {
    letter: "B",
    question: "¿Cuál es la bebida alcohólica favorita del grupo?",
    answer: "beer"
  },
  {
    letter: "C",
    question: "¿Cuántos cumpleaños hemos celebrado juntos?",
    answer: "cumpleanos"
  },
  {
    letter: "D",
    question: "¿Cuál fue el drama más grande que tuvimos como grupo?",
    answer: "discordia"
  },
  {
    letter: "E",
    question: "¿Cuál es el emoji que más usamos en el chat?",
    answer: "emoji"
  },
  {
    letter: "F",
    question: "¿Cuántas fotos grupales tenemos oficiales?",
    answer: "fotos"
  },
  {
    letter: "G",
    question: "¿Quién gasta más dinero en las salidas?",
    answer: "gastos"
  },
  {
    letter: "H",
    question: "¿Cuántos hermanos tiene en total el grupo?",
    answer: "hermanos"
  },
  {
    letter: "I",
    question: "¿Cuántos idiomas habla el grupo en total?",
    answer: "idiomas"
  },
  {
    letter: "J",
    question: "¿Cuál es nuestro jefe común o máxima autoridad?",
    answer: "jefe"
  },
  {
    letter: "K",
    question: "¿Quién es el killjoy del grupo (mata la diversión)?",
    answer: "killjoy"
  },
  {
    letter: "L",
    question: "¿Cuántas libras perdió el grupo en total en dietas?",
    answer: "libras"
  },
  {
    letter: "M",
    question: "¿Cuántos metros manejamos para las reuniones cada año?",
    answer: "metros"
  },
  {
    letter: "N",
    question: "¿Cuántas noches nos hemos dormido juntos?",
    answer: "noches"
  },
  {
    letter: "O",
    question: "¿Cuántos ojos tiene el grupo en total?",
    answer: "ojos"
  },
  {
    letter: "P",
    question: "¿Cuántos piercing tiene alguien del grupo?",
    answer: "piercing"
  },
  {
    letter: "Q",
    question: "¿Cuánto quedó debiendo alguien del grupo?",
    answer: "quilos"
  },
  {
    letter: "R",
    question: "¿Cuántas recaídas tuvo alguien famoso del grupo?",
    answer: "recaidas"
  },
  {
    letter: "S",
    question: "¿Cuántos son solteros actualmente en el grupo?",
    answer: "solteros"
  },
  {
    letter: "T",
    question: "¿Cuántas tatuajes en total tiene el grupo?",
    answer: "tatuajes"
  },
  {
    letter: "U",
    question: "¿Cuántas ureñas estudió alguien del grupo?",
    answer: "universo"
  },
  {
    letter: "V",
    question: "¿Cuántas voces diferentes cantan en el grupo?",
    answer: "voces"
  },
  {
    letter: "W",
    question: "¿Cuántas watsappeadas hemos dado sin razón?",
    answer: "whatsapp"
  },
  {
    letter: "X",
    question: "¿Cuánto X factor tiene nuestro grupo?",
    answer: "xplosion"
  },
  {
    letter: "Y",
    question: "¿Cuál es el youtube que más vemos juntos?",
    answer: "youtuber"
  },
  {
    letter: "Z",
    question: "¿Cuántos zancadillas nos hemos dado de broma?",
    answer: "zancadas"
  }
];

// Backward compatibility with old code
export const wordGameData = pattern1;

// Export only the two patterns used in the game
export const patterns = [pattern1, pattern2];

export const createEmptyScores = (players) => {
  const scores = {};
  players.forEach(player => {
    scores[player.id] = {
      playerId: player.id,
      playerName: player.name,
      phase1: 0,
      phase2: 0,
      phase3: 0,
      total: 0
    };
  });
  return scores;
};

// Función para crear 2 equipos aleatorios
export const createRandomTeams = (players) => {
  if (!players || players.length === 0) return [];

  // Hacer una copia y mezclar aleatoriamente los jugadores
  const shuffled = [...players].sort(() => Math.random() - 0.5);

  // Dividir en dos grupos
  const midpoint = Math.ceil(shuffled.length / 2);
  const team1Players = shuffled.slice(0, midpoint);
  const team2Players = shuffled.slice(midpoint);

  // Create teams with assigned patterns
  const teams = [
    {
      id: 1,
      name: team1Players.map(p => p.name).join(' & '),
      players: team1Players,
      patternId: 0 // pattern1
    },
    {
      id: 2,
      name: team2Players.map(p => p.name).join(' & '),
      players: team2Players,
      patternId: 1 // pattern2
    }
  ];

  return teams;
};

// NORDICS SAY - Game 2
export const nordicsSayThemes = [
  {
    id: 1,
    question: "¿Quién es el primero que se te ocurre si digo \"Femboy\"?",
    answers: [
      { name: "Maciel", percentage: 87.5 },
      { name: "Manuel", percentage: 75 },
      { name: "Jairo", percentage: 12.5 },
      { name: "Facundo", percentage: 0 }
    ]
  },
  {
    id: 2,
    question: "Alguien llegó tarde ¿Quién fue?",
    answers: [
      { name: "Manuel", percentage: 62.5 },
      { name: "Pablo", percentage: 50 },
      { name: "Bruno", percentage: 50 },
      { name: "Cristian", percentage: 12.5 }
    ]
  },
  {
    id: 3,
    question: "En el grupo hay más gente de...",
    answers: [
      { name: "Nacional", percentage: 100 },
      { name: "Madrid", percentage: 50 },
      { name: "Barcelona", percentage: 37.5 },
      { name: "Peñarol", percentage: 0 }
    ]
  },
  {
    id: 4,
    question: "¿Quién es el más Otaku?",
    answers: [
      { name: "Jairo", percentage: 75 },
      { name: "Bruno", percentage: 50 },
      { name: "Maciel", percentage: 50 },
      { name: "Nacho", percentage: 0 }
    ]
  },
  {
    id: 5,
    question: "¿Quién prioriza más otros grupos de amigos?",
    noPoints: true,
    answers: [
      { name: "Manuel Perera", percentage: 87.5 },
      { name: "Perera Manuel", percentage: 87.5 },
      { name: "Manuel", percentage: 75 },
      { name: "Manu", percentage: 75 }
    ]
  },
  {
    id: 6,
    question: "Emoji más usado por el grupo",
    answers: [
      { name: "🤣", percentage: 100 },
      { name: "😮", percentage: 50 },
      { name: "👻", percentage: 25 },
      { name: "🤮", percentage: 0 }
    ]
  },
  {
    id: 7,
    question: "Mejor de los últimos DTs de Nacional",
    answers: [
      { name: "Lasarte", percentage: 75 },
      { name: "Peirano", percentage: 75 },
      { name: "Chino", percentage: 12.5 },
      { name: "Jadson", percentage: 12.5 }
    ]
  },
  {
    id: 8,
    question: "Mejor jugador del mundo",
    answers: [
      { name: "Mbappe", percentage: 87.5 },
      { name: "Haaland", percentage: 50 },
      { name: "Lamine Yamal", percentage: 25 },
      { name: "Pedri", percentage: 12.5 }
    ]
  },
  {
    id: 9,
    question: "¿Quién habla más por Discord?",
    answers: [
      { name: "Manuel", percentage: 62.5 },
      { name: "Facundo", percentage: 37.5 },
      { name: "Bruno", percentage: 25 },
      { name: "Nacho", percentage: 25 }
    ]
  },
  {
    id: 10,
    question: "En quién pensás si dicen \"Pollera\"",
    answers: [
      { name: "Pablo", percentage: 75 },
      { name: "Facundo", percentage: 62.5 },
      { name: "Manuel", percentage: 62.5 },
      { name: "Maciel", percentage: 12.5 }
    ]
  },
  {
    id: 11,
    question: "¿Quién tiene el peor gusto en juegos?",
    answers: [
      { name: "Bruno", percentage: 57.1 },
      { name: "Jairo", percentage: 57.1 },
      { name: "Manuel", percentage: 42.9 },
      { name: "Nacho", percentage: 14.3 }
    ]
  },
  {
    id: 12,
    question: "Si alguien tiene que errar un penal para salvarte la vida ¿a quién se lo das?",
    answers: [
      { name: "Bruno", percentage: 87.5 },
      { name: "Maciel", percentage: 62.5 },
      { name: "Pablo", percentage: 25 },
      { name: "Manuel", percentage: 12.5 }
    ]
  },
  {
    id: 13,
    question: "Te ibas a juntar con alguien pero hizo otros planes ¿Quién fue?",
    answers: [
      { name: "Manuel", percentage: 87.5 },
      { name: "Maciel", percentage: 37.5 },
      { name: "Facundo", percentage: 25 },
      { name: "Bruno", percentage: 25 }
    ]
  },
  {
    id: 14,
    question: "¿Quién es el más \"termo\" con su cuadro?",
    answers: [
      { name: "Manuel", percentage: 62.5 },
      { name: "Bruno", percentage: 62.5 },
      { name: "Maciel", percentage: 37.5 },
      { name: "Facundo", percentage: 25 }
    ]
  }
];

// PHRASES FOR "WHO SAID THIS?" - Phase 3
export const whoSaidThis = [
  {
    id: 1,
    quote: "Que se graben así cuento las veces que estoy enfrente al arco y no la pasan o pasan al que está marcado",
    author: "Maciel"
  },
  {
    id: 2,
    quote: "si quedo, pago las pizzas",
    author: "Facundo"
  },
  {
    id: 3,
    quote: "A veces los amigos son como las calles, tienen un solo sentido, las cosas van pero no vuelven",
    author: "crisonico"
  },
  {
    id: 4,
    quote: "Pase tanto tiempo buscando el clitoris que me perdi a mi mismo",
    author: "pablo"
  },
  {
    id: 5,
    quote: "La carita de cógeme, es increible",
    author: "Jairo"
  },
  {
    id: 6,
    quote: "y me di cuenta como no hacen medio pase, ustedes",
    author: "Maciel"
  },
  {
    id: 7,
    quote: "Y este cuando te lo vas clavar",
    author: "Nacho"
  },
  {
    id: 8,
    quote: "Nicolas es medio burro, lucas juega bien",
    author: "Facundo"
  },
  {
    id: 9,
    quote: "Unas ganas de hacerle el amor a una nenita toda la noche",
    author: "Manuel"
  },
  {
    id: 10,
    quote: "porque no tenemos a alguien asi atrás?",
    author: "Bruno"
  },
  {
    id: 11,
    quote: "Estoy para probar algún pibe chico",
    author: "Manuel"
  },
  {
    id: 12,
    quote: "Unas ganas de repetir la masacre de texas en la colita del bruno. Estoy para una perso",
    author: "Dani"
  }
];

// ZOOM GUESS GAME - Imágenes para adivinar
export const zoomGuessImages = [
  {
    id: 1,
    fileName: "IMG-20221219-WA0041.jpg",
    hint: "Imagen 1"
  },
  {
    id: 2,
    fileName: "IMG-20230413-WA0002.jpg",
    hint: "Imagen 2"
  },
  {
    id: 3,
    fileName: "IMG-20230619-WA0101.jpg",
    hint: "Imagen 3"
  },
  {
    id: 4,
    fileName: "IMG-20230720-WA0045.jpg",
    hint: "Imagen 4"
  },
  {
    id: 5,
    fileName: "IMG-20230813-WA0013 (1).jpg",
    hint: "Imagen 5"
  },
  {
    id: 6,
    fileName: "IMG-20231110-WA0008.jpg",
    hint: "Imagen 6"
  },
  {
    id: 7,
    fileName: "IMG-20240530-WA0058.jpg",
    hint: "Imagen 7"
  },
  {
    id: 8,
    fileName: "IMG-20240616-WA0066.jpg",
    hint: "Imagen 8"
  },
  {
    id: 9,
    fileName: "IMG-20241116-WA0036.jpg",
    hint: "Imagen 9"
  },
  {
    id: 10,
    fileName: "IMG-20250125-WA0002.jpg",
    hint: "Imagen 10"
  },
  {
    id: 11,
    fileName: "IMG-20250209-WA0144.jpg",
    hint: "Imagen 11"
  },
  {
    id: 12,
    fileName: "IMG-20250228-WA0026.jpg",
    hint: "Imagen 12"
  },
  {
    id: 13,
    fileName: "IMG-20250328-WA0005.jpg",
    hint: "Imagen 13"
  },
  {
    id: 14,
    fileName: "IMG-20250509-WA0022.jpg",
    hint: "Imagen 14"
  },
  {
    id: 15,
    fileName: "IMG-20250726-WA0024.jpg",
    hint: "Imagen 15"
  },
  {
    id: 16,
    fileName: "IMG_20220226_002149.jpg",
    hint: "Imagen 16"
  },
  {
    id: 17,
    fileName: "IMG_20221106_001612.jpg",
    hint: "Imagen 17"
  },
  {
    id: 18,
    fileName: "IMG_20221218_195203.jpg",
    hint: "Imagen 18"
  },
  {
    id: 19,
    fileName: "IMG_20230511_222612.jpg",
    hint: "Imagen 19"
  },
  {
    id: 20,
    fileName: "IMG_20230619_111822.jpg",
    hint: "Imagen 20"
  },
  {
    id: 21,
    fileName: "IMG_20250125_080111.jpg",
    hint: "Imagen 21"
  },
  {
    id: 22,
    fileName: "20250125_053212.jpg",
    hint: "Imagen 22"
  },
  {
    id: 23,
    fileName: "20250126_185849.jpg",
    hint: "Imagen 23"
  },
  {
    id: 24,
    fileName: "20251026_181920.jpg",
    hint: "Imagen 24"
  },
  {
    id: 25,
    fileName: "20251109_212620.jpg",
    hint: "Imagen 25"
  },
  {
    id: 26,
    fileName: "866c03d7-a84c-4616-8fdc-1c7a134af510.jpg",
    hint: "Imagen 26"
  },
  {
    id: 27,
    fileName: "IMG-20251104-WA0000.jpg",
    hint: "Imagen 27"
  },
  {
    id: 28,
    fileName: "IMG_1331.HEIC",
    hint: "Imagen 28"
  },
  {
    id: 29,
    fileName: "IMG_1479.HEIC",
    hint: "Imagen 29"
  }
];
